// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"19":"10446dea46188b6c","1854":"7068d63de6254f80","3003":"9d51fb99d18f5290","3850":"7b545c20221c628a","6329":"871b5cac3fac08f8","7892":"a9874d609f2a0665","8490":"747249bb2bbfae4e","9334":"014d80da3554d703"}[chunkId] + ".js";
};